class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.currentMode = null;
    this._resizeHandler = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initSlider();
    window.addEventListener("resize", this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._resizeHandler);
    this.destroySlider();
  }

  handleResize() {
    const newMode = this.getMode();
    if (newMode !== this.currentMode) {
      this.destroySlider();
      this.initSlider();
    } else if (this.swiperInstance?.params.autoHeight) {
      // same mode but resize → update height
      this.swiperInstance.updateAutoHeight(300);
    }
  }

  getMode() {
    return window.innerWidth >= 850 ? "desktop" : "tablet";
  }

  getDesktopConfig(list) {
    return {
      slidesPerView: Number(this.dataset.desktopSlides) || "auto",
      spaceBetween: Number(this.dataset.desktopSpacebetween) || 20,
      centeredSlides: this.dataset.desktopCenterslides === "true",
      loop: this.dataset.desktopLoop === "true",
      autoHeight: this.dataset.desktopAutoheight === "true",

      navigation:
        this.dataset.desktopArrows === "true"
          ? {
              nextEl: list.querySelector(".swiper-button-next"),
              prevEl: list.querySelector(".swiper-button-prev"),
            }
          : false,

      pagination:
        this.dataset.desktopPagination === "true"
          ? {
              el: list.querySelector(".swiper-pagination"),
              type: "progressbar",
            }
          : false,

      on: {
        init: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(0);
          }
        },
        slideChangeTransitionEnd: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(300);
          }
        },
        imagesReady: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(0);
          }
        },
      },
    };
  }

  getTabletConfig(list) {
    return {
      slidesPerView: Number(this.dataset.mobileSlides) || "auto",
      spaceBetween: Number(this.dataset.mobileSpacebetween) || 10,
      centeredSlides: this.dataset.mobileCenterslides === "true",
      loop: this.dataset.mobileLoop === "true",
      autoHeight: this.dataset.mobileAutoheight === "true",

      navigation:
        this.dataset.mobileArrows === "true"
          ? {
              nextEl: list.querySelector(".swiper-button-next"),
              prevEl: list.querySelector(".swiper-button-prev"),
            }
          : false,

      pagination:
        this.dataset.mobilePagination === "true"
          ? {
              el: list.querySelector(".swiper-pagination"),
              type: "progressbar",
            }
          : false,

      on: {
        init: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(0);
          }
        },
        slideChangeTransitionEnd: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(300);
          }
        },
        imagesReady: (swiper) => {
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight(0);
          }
        },
      },
    };
  }

  initSlider() {
    const mode = this.getMode();
    this.currentMode = mode;

    let list = null;
    if (
      (mode === "desktop" && this.classList.contains("swiper--desktop")) ||
      (mode !== "desktop" && this.classList.contains("swiper--tablet"))
    ) {
      list = this;
    }

    if (!list) return;

    const config =
      mode === "desktop"
        ? this.getDesktopConfig(list)
        : this.getTabletConfig(list);

    this.swiperInstance = new Swiper(list, config);

    // 🔥 Safety: ensure height correct after init
    if (this.swiperInstance.params.autoHeight) {
      setTimeout(() => {
        this.swiperInstance.updateAutoHeight(0);
      }, 50);
    }
  }

  destroySlider() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("swiper-component", SwiperComponent);
